import { render } from "./FormForm.vue?vue&type=template&id=adb84c18&scoped=true"
import script from "./FormForm.vue?vue&type=script&lang=js"
export * from "./FormForm.vue?vue&type=script&lang=js"

import "./FormForm.vue?vue&type=style&index=0&id=adb84c18&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adb84c18"]])

export default __exports__